/*
 * @Description: 
 * @Author: dezhi
 * @Date: 2019-08-26 09:11:29
 * @LastEditTime: 2021-06-02 17:53:53
 * @LastEditors: dezhi
 */
import axios from "@/assets/js/http";
import baseConf from '@/assets/js/conf';

const state = {
    studentInfo: {}
}

// getters
const getters = {

}

// actions
const actions = {
    /**
    * @description: 获取微信openid
    * @param {code} 微信授权code
    * @param {flag} 标识
    * @return {type} 
    */
    async getOpenIdAction({ commit, state }, payload) {
        const res = await axios({
            url: '/v1.0.0/user/app/auth/wx/login/1',
            method: 'get',
            params: {
                code: payload,
                // flag: baseConf.wxFlag
            }
        })
        if (res.data.status == 2000) {
            let data = res.data.data;
            // commit('saveUserInfo', data.userInfo)
            // commit('saveToken', data.token)
        }
        return res;
    },
    /**
     * @description: 绑定手机号
     * @param {openid} 微信openid
     * @param {refreshToken} 微信token
     * @param {phone} 手机号
     * @param {code} 微信授权code
     * @param {flag} 标识
     * @return {type} 
     */
    async bindWechatAction({ commit, state }, payload) {
        const res = await axios({
            url: '/v1.0.0/user/wx/preLoginPhone',
            method: 'post',
            data: payload
        })
        if (res.data.status == 2000) {
            let data = res.data.data;

            // Cookies.set('auth', data.userInfo.id)
            // Cookies.set('authToken', data.token)
            // // 设置用户id和token到cookie
            // commit('saveUserInfo', data.userInfo)
            // commit('saveToken', data.token)
        }
        return res;
    },
    /**
      * @description: 绑定手机号
      * @param {openid} 微信openid
      * @param {refreshToken} 微信token
      * @param {phone} 手机号
      * @param {code} 微信授权code
      * @param {flag} 标识
      * @return {type} 
      */
    async bindMobileRegistAction({ commit, state }, payload) {
        const res = await axios({
            url: '/v1.0.0/user/wx/preLoginPwd',
            method: 'post',
            data: payload
        })
        if (res.data.status == 2000) {
            let data = res.data.data;
        }
        return res;
    },
    /**
     * @description: 获取accessToken
     * @param {type} 
     * @return {type} 
     */
    async getAccessTokenAction() {
        const res = await axios.get(`https://api.weixin.qq.com/cgi-bin/token?grant_type=client_credential&appid=${baseConf.wxAppid}&secret=${baseConf.wxSecret}`);
        if (res.data.errcode == 0) {
            localStorage.setItem('accessToken', res.data.access_token)
        } else {
            localStorage.removeItem('accessToken')
        }

    },

    async getLikeUserIdAct({ commit, state }, payload) {
        const res = await axios({
            url: `/v1.0.0/luxun/likeuser/insert`,
            method: 'get',
            params: {
                code: payload
            }
        })

        return res
    },

    async likesAct({ commit, state }, payload) {
        const res = await axios({
            url: `/v1.0.0/luxun/love`,
            method: 'post',
            data: payload
        })

        return res
    },
    async webShareAct({ commit, state }, payload) {
        const res = await axios({
            url: `/v1.0.0/user/dooruser/sharelx/`,
            method: 'get',
            params: {
                url: payload
            }
        })

        return res
    },
    /**
    * @description: 获取支付用的随机串等参数
    * @param {type} 
    * @return: 
    */
    async getWxpayStrAct({ commit }, payload) {
        // const res = await axios.post(`/v1.0.0/order/product/weChatPayment/orders`, payload)
        const res = await axios({
            url: `/v1.0.0/order/product/weChatAgencyPayment/agencyOrders`,
            method: 'post',
            data: payload
        })
        return res
    },
    /**
     * @description: native 支付
     * @param {type} 
     * @return: 
     */
    async nativePaymentAct({ commit, rootState }, payload) {
        const res = await axios({
            url: `/v1.0.0/order/cwaOrder/cwaWechatNative`,
            method: 'post',
            data: payload,
        })
        return res
    },
    /**
     * @description: jsapi 支付
     * @param {type} 
     * @return: 
     */
    async jsapiPaymentAct({ commit, rootState }, payload) {
        const res = await axios({
            url: `/v1.0.0/order/cwaOrder/cwaWechatJs`,
            method: 'post',
            data: payload,
        })
        return res
    },
    /**
    * @description: jsapi 支付
    * @param {type} 
    * @return: 
    */
    async getOpenIdAct({ commit, rootState }, payload) {
        const res = await axios({
            url: `/v1.0.0/order/cwaOrder/getCwaOpenId`,
            method: 'post',
            data: {
                code: payload
            },
        })
        return res
    },



}


// mutations

const mutations = {
    saveStudentInfo(state, payload) {
        // state.classInfo = state.infoList[payload - 1];
        state.studentInfo = payload;
    }
}



export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}